import { render, staticRenderFns } from "./ChemicalsToxprints.vue?vue&type=template&id=84b12c88&scoped=true"
import script from "./ChemicalsToxprints.vue?vue&type=script&lang=js"
export * from "./ChemicalsToxprints.vue?vue&type=script&lang=js"
import style0 from "./ChemicalsToxprints.vue?vue&type=style&index=0&id=84b12c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b12c88",
  null
  
)

export default component.exports